import { FunctionComponent, PropsWithChildren } from "react";

import useButtonCopy, { UseButtonCopyProps } from "./useButtonCopy";

import { ButtonProps, DashboardButton } from "@/dashboard-design-system/Button";

export type ButtonCopyProps = UseButtonCopyProps & ButtonProps;

export const ButtonCopy: FunctionComponent<PropsWithChildren<ButtonCopyProps & ButtonProps>> = ({
  toCopy,
  loading,
  onClick,
  copyText: propsCopyText,
  copiedText: propsCopiedText,
  amplitudeEvent,
  amplitudePayload,
  ...rest
}) => {
  const { copyLink, text, copiedText } = useButtonCopy({
    toCopy,
    copyText: propsCopyText,
    copiedText: propsCopiedText,
    loading,
    amplitudeEvent,
    amplitudePayload,
    onClick,
  });

  return (
    <DashboardButton {...rest} disabled={text === copiedText || loading} onClick={copyLink}>
      {text}
    </DashboardButton>
  );
};
